import { render, staticRenderFns } from "./CalendarWithShift.vue?vue&type=template&id=b4af54e2&"
import script from "./CalendarWithShift.vue?vue&type=script&lang=js&"
export * from "./CalendarWithShift.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWithShift.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports